import { useSearchFilters } from "./useSearchFilters";

class Sort {
    constructor (id, title, asc = true) {
        this.id = id
        this.title = title
        this.asc = asc
    }
    
    sort(items) {
        return items.toSorted(this.compare.bind(this))
    }
    
    compare(a, b) {
        const valueA = this.value(a)
        const valueB = this.value(b)

        if (this.asc) {
            if (valueA === null) return valueB
            if (valueB === null) return valueA
            return valueA - valueB;
        }

        if (valueB === null) return valueA
        if (valueA === null) return valueB
        return valueB - valueA;
    }
    
    value(item) {
        return 0
    }
}

class PriceSort extends Sort {
    value(item) {
        return item.prices.price_sort || 0
    }
}

class ClassSort extends Sort {
    value(item) {
        return item.aircraft.class?.sort || null
    }
}
class YearSort extends Sort {
    value(item) {
        return item.aircraft.year || null
    }
}

class HeightSort extends Sort {
    value(item) {
        return item.aircraft.height || null
    }
}

export default function useSearchSort() {
    const [ sortList, setSortList ] = React.useState([])
    
    const loadSortList = React.useCallback(() => {
        setSortList([
            new PriceSort('price:asc', __('search.sort.priceLowToHigh'), true),
            new PriceSort('price:desc', __('search.sort.priceHighToLow'), false),
            new ClassSort('class:asc', __('search.sort.classLightToHeavy'), true),
            new ClassSort('class:desc', __('search.sort.classHeavyToLight'), false),
            new YearSort('year:asc', __('search.sort.yearOldestToNewest'), true),
            new YearSort('year:desc', __('search.sort.yearNewestToOldest'), false),
            new HeightSort('height:asc', __('search.sort.cabinHeightLowToHigh'), true),
            new HeightSort('height:desc', __('search.sort.cabinHeightHighToLow'), false),
        ])
    }, [])
    
    const sortItems = React.useCallback((items, currentSort) => {
        currentSort = currentSort || (sortList && sortList[0] ? sortList[0].id : undefined)
        const sort = sortList.find(e => e.id === currentSort)
        if (!sort)
            return items
        
        return sort.sort(items)
    }, [ sortList ])

    React.useEffect(() => {
        loadSortList()
    }, [])
    
    return {
        // data
        sort: sortList,
        
        // functions
        loadSortList,
        sortItems,
    }
}

export function withSearchSortHook(Component) {
    return function ( props ) {
        const searchSort = useSearchSort();
        return <Component {...props} searchSort={searchSort} />
    }
}
